// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "libphonenumber" + "." + "a5a4a2d2" + ".js";
};